import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {HtmlParse} from 'utils';
import Tcenco from 'images/payments/cencosudscotibank.svg';
import MasterCard from 'images/payments/mastercad.svg';
import Visa from 'images/payments/visa.svg';
import AmericanExpress from 'images/payments/americanexpress.svg';
import Magna from 'images/payments/magna.svg';
import DinersClub from 'images/payments/dinersclub.svg';
import Redcompra from 'images/payments/redcompra.svg';
import { walletPaymentsName } from "config/index";
import style from './style.scss';//NOSONAR


const NewCardAcountItem = (props) => {

    const card = props.card;
    const callbackSelected = props.callbackSelected ? props.callbackSelected : ()=>{};
    const callbackDelete = props.callbackDelete ? props.callbackDelete : ()=>{};
    const quickPurchase = props.quickPurchase;
    const oneClick = walletPaymentsName.oneClick;
    const catOneClick = walletPaymentsName.catOneClick; 
    const debitOneClick = walletPaymentsName.debitOneClick;
    const [check, setCheck] = useState(card ? card.isFavorite : '');
    const [image, setImage] = useState(null);
    const [timefavorite, setTimefavorite] = useState(false);
    const [cardTitle, setCardTitle] = useState(null);


    useEffect(() => {
        if (card && card.paymentMethod === catOneClick) {
            setCardTitle('Tarjeta de crédito');
            setImage(Tcenco)
        }

        if (card && card.paymentMethod === debitOneClick) {
            setCardTitle('Tarjeta de débito');
            setImage(Redcompra)
        }

        if((card && card.paymentMethod === oneClick)) {
            setCardTitle('Tarjeta de crédito');
            switch(card.brand) {
                case 'MasterCard':
                    setImage(MasterCard);
                    break
                case 'Visa':
                    setImage(Visa);
                    break
                case 'AmericanExpress':
                    setImage(AmericanExpress);
                    break
                case 'Magna':
                    setImage(Magna);
                    break
                case 'DinersClub':
                    setImage(DinersClub);
                    break
            }
        }
        setCheck(card && card.isFavorite);
        setTimefavorite(card && card.isFavorite);
        let timeout = null
        timeout = setTimeout(() =>{
            setTimefavorite(false);
        }, 8000)

        return function cleanup(){
            clearTimeout(timeout);
        }
    }, [props.card]);



    const onClick = (event) => {
        if (!check ) {
            event.preventDefault();
            callbackSelected(card);
            setCheck(true);
        }

    }

    if(!card) return '';

    return (
        <section className="card-acount-item new-card-acount">
            <div className="card-item-wrap">
                <div className="card-elemnts-wrap">
                    <div className={"card-item-image " + ((card.brand === 'Visa') ? ' visa-card' : '')} onClick={event =>onClick(event)}><i>{HtmlParse(image)}</i></div>
                    <div className="card-item-info-wrap">
                        <div className="card-item-title-icons" >
                            <div className="payment-method-name" onClick={event =>onClick(event)}>{cardTitle}</div>
                            {!quickPurchase ? <div className="card-item-icons-wrap">
                                <i className={"card-item-star  " + ((card.isFavorite) ? ' jumbo-icon-star active ' : ' jumbo-icon-new-star ')} onClick={() => callbackSelected(card)}></i>
                                <div className={'tooltip-container ' + ((timefavorite) ? 'active' : '') }>
                                    <i onClick={() => callbackDelete(card)} className="card-item-trash jumbo-icon-new-trash"></i>
                                    <span className="tooltip">Puedes eliminar tu tarjeta una vez que tu pedido haya sido recolectado y la boleta haya sido emitida.</span>
                                </div>
                            </div> : ''}
                        </div>
                        <div className="card-item-number" onClick={event =>onClick(event)}>
                            <span className="card-item-text-number"> **** {card.lastDigits}</span>
                            {(card.isFavorite) && <span className="card-item-text-favorite">Predeterminada</span>}
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

NewCardAcountItem.propTypes = {
    card: PropTypes.object,
    callbackSelected: PropTypes.func,
    callbackDelete: PropTypes.func,
    quickPurchase: PropTypes.bool,
}


export default NewCardAcountItem;